import React from 'react';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import SimpleCard from './SimpleCard';
import Phone from 'material-ui-icons/Phone'
import Email from 'material-ui-icons/Email'
import LocationCity from 'material-ui-icons/LocationCity'
import People from 'material-ui-icons/People'
import Person from 'material-ui-icons/Person'
import Today from 'material-ui-icons/Today'
import FormatListNumbered from 'material-ui-icons/FormatListNumbered'
import CheckBox from 'material-ui-icons/CheckBox'
import Hotel from 'material-ui-icons/Hotel'
import ContentPaste from 'material-ui-icons/ContentPaste'
import Payment from 'material-ui-icons/Payment'

const styles = theme => ({
  root: {
    display: 'flex',
  },
  list: {
    textAling: 'left',
    backgroundColor: 'red',
  },
  icon: {
    position: 'relative',
    width: 16,
    height: 16,
    top: 4,
    marginRight: 3,
  }
});

class EndingInfo extends React.Component {
  state = {
    value: '',
  };

  handleChange = (event, value) => {
    this.setState({ value });
    this.props.choiceHandler( value );
  };

  generateContent = (classes, hotel, participants) => {
    const max = {
      players: 15,
      staff: 2,
    }
    const min = {
      players: 7,
      staff: 1,
    }
    const players = participants.players > max.players ? max.players : participants.players < min.players ? min.players : participants.players;
    const staff = participants.staff > max.staff ? max.staff : participants.staff < min.staff ? min.staff : participants.staff;

    // const playerIcon = 'J' ;
    // const staffIcon = 'CT' ;

    const unitPrice = hotel.price;
    const html = 
    <div style={{textAlign: 'left'}}>
      <Typography type="body2">
        <Hotel className={classes.icon} />{hotel.name} <br /> <br />
        <ContentPaste className={classes.icon} />Inscripción: 100€<br />
        {/* Estancia: {unitPrice}€ x ({players} {playerIcon} + {staff} {staffIcon}) = {(players + staff) * unitPrice}€ <br /> */}
        <Hotel className={classes.icon} />Estancia: {(players + staff) * unitPrice}€ <br />
        <Payment className={classes.icon} /><strong>Total: {100 + (players + staff) * unitPrice}€ (IVA incluido)</strong>
      </Typography>
    </div>
    return html;
  }


  render() {
    const {classes} = this.props;
    const {boarding, contactData, dates, hotel, participants} = this.props.filledData;
    const html = 
      <div>
        <Typography type="body1"> Estás a punto de confirmar la inscripción en AF7-2018 con las siguientes características:</Typography><br /><br />
        <Typography type="body1"> <strong>Datos de contacto:</strong></Typography>
        <Typography type="body2"> 
          <Person className={classes.icon} />{contactData.name}<br />
          <Phone className={classes.icon} />{contactData.phone}<br />
          <Email className={classes.icon} />{contactData.email}
        </Typography><br />
        <Typography type="body1"> <strong>Equipo registrado:</strong></Typography>
        <Typography type="body2"> 
          <People className={classes.icon} />{contactData.team} <br />
          <LocationCity className={classes.icon} />{contactData.city}
        </Typography><br />
        <Typography type="body1"> <strong>Turno de competición:</strong></Typography>
        <Typography type="body2"> 
          <Today className={classes.icon} />{dates.headline}
        </Typography><br />
        <Typography type="body1"> <strong>Número de inscritos:</strong></Typography>
        <Typography type="body2">
          <FormatListNumbered className={classes.icon} />{participants.players} jugadores y {participants.staff} adulto{participants.staff > 1 ? 's': ''}
        </Typography><br />
        <Typography type="body1"> <strong>Paquete de inscripción:</strong></Typography>
        <Typography type="body2"> 
          <CheckBox className={classes.icon} />{boarding.headline}
        </Typography>
        {boarding.key !== 'only-registry' && this.generateContent(classes, hotel, participants)}

      </div>;


    return (
      <SimpleCard headline='Confirmación' content={html}/>
    );
  }
}

// EndingInfo.propTypes = {};

export default withStyles(styles)(EndingInfo);


// WEBPACK FOOTER //
// ./src/components/EndingInfo.jsx